import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckExtraPathMoIds } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithArray } from '@utils/formatter';

import { TConsistencyCheckHistoryExtraPathMoIdsDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_EXTRA_PATH_MO_IDS } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckExtraPathMoIdsReturned {
	moIds: TSelectOption<string>[];
	isLoadingMoIds: boolean;
}

const useQueryConsistencyCheckExtraPathMoIds = (
	params: Partial<TConsistencyCheckHistoryExtraPathMoIdsDTO>,
): IUseQueryConsistencyCheckExtraPathMoIdsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<string[], TSelectOption<string>[]>({
		queryKey: [CONSISTENCY_CHECK_EXTRA_PATH_MO_IDS, params],
		queryFn: extractQueryParams(getConsistencyCheckExtraPathMoIds),
		select: (data) => optionsFormattedWithArray(data),
		enabled: [
			params.dumpConsistencyId,
			params.dataModelPathId,
			params.moName,
		],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		moIds: data || [],
		isLoadingMoIds: isInitialLoading,
	};
};

export default useQueryConsistencyCheckExtraPathMoIds;
